import React from "react";
import OrdersList from "../components/OrdersList";

const UserOrdersPage = () => {
  return (
    <div className="orders-page">
      <OrdersList />
    </div>
  );
};

export default UserOrdersPage;
